import { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { guestApi } from "@/lib/guest";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Star } from "lucide-react";

export default function FeedbackPublic() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const [rating, setRating] = useState(5);
  const [form, setForm] = useState({ name: "", phone: "", comment: "" });
  const [done, setDone] = useState(false);
  const table = params.get("table") || "";

  if (!slug) {
    return (
      <div className="min-h-screen grid place-items-center p-8 text-center">
        <div>
          <h1 className="font-display text-2xl font-800">Open your restaurant’s feedback page</h1>
          <p className="text-neutral-500 mt-2">Use <code>/r/your-slug/feedback</code> from Settings.</p>
        </div>
      </div>
    );
  }

  const submit = async () => {
    if (!form.phone) return toast.error("Phone helps us link this to your visits");
    if (!slug) return toast.error("Open this page from your restaurant feedback link");
    await api.post(guestApi(slug, "/feedback"), { ...form, rating, table_name: table });
    setDone(true);
  };

  if (done) {
    return (
      <div className="min-h-screen grid place-items-center p-6">
        <div className="text-center">
          <div className="font-display text-3xl font-800">Thank you</div>
          <p className="text-neutral-500 mt-2">Your feedback was saved to our CRM.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#FAFAFA]" data-testid="feedback-public">
      <div className="kul-card p-8 max-w-md w-full space-y-4">
        <h1 className="font-display text-2xl font-800">How was your meal?</h1>
        {table && <p className="text-sm text-neutral-500">Table {table}</p>}
        <div className="flex gap-1">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} onClick={() => setRating(n)}>
              <Star className={`w-8 h-8 ${n <= rating ? "fill-[#FFCC00] text-[#FFCC00]" : "text-neutral-300"}`} />
            </button>
          ))}
        </div>
        <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
        <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
        <div><Label>Comment</Label><textarea value={form.comment} onChange={(e) => setForm({ ...form, comment: e.target.value })} rows={3} className="w-full rounded-lg border p-2 text-sm" /></div>
        <Button onClick={submit} className="w-full h-11 bg-[var(--kul-primary)] text-white">Submit</Button>
      </div>
    </div>
  );
}
